import React from "react";

export const PlanificationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none">
      <mask
        id="mask0_285_1492"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="26"
        height="26">
        <path
          d="M3.125 11.875H26.875V25.625C26.875 25.9565 26.7433 26.2745 26.5089 26.5089C26.2745 26.7433 25.9565 26.875 25.625 26.875H4.375C4.04348 26.875 3.72554 26.7433 3.49112 26.5089C3.2567 26.2745 3.125 25.9565 3.125 25.625V11.875Z"
          fill="white"
          stroke="white"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M3.125 6.25C3.125 5.91848 3.2567 5.60054 3.49112 5.36612C3.72554 5.1317 4.04348 5 4.375 5H25.625C25.9565 5 26.2745 5.1317 26.5089 5.36612C26.7433 5.60054 26.875 5.91848 26.875 6.25V11.875H3.125V6.25Z"
          stroke="white"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M10 19.375L13.75 23.125L21.25 15.625"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 3.125V8.125M20 3.125V8.125"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </mask>
      <g mask="url(#mask0_285_1492)">
        <path d="M0 0H30V30H0V0Z" fill="#2481A6" />
      </g>
    </svg>
  );
};
